import React from "react";
import Swal from "sweetalert2";
import { useStore } from "./store";
import { Button } from "./components/Button";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100dvh"
};

const iconStyle = {
  width: 80,
  height: 80,
  margin: 8
};

const titleStyle = {
  fontSize: 32,
  fontWeight: 800
};

const inputBoxStyle = {
  display: "flex",
  flexDirection: "column",
  width: 400,
  marginTop: 32,
  gap: 16
};

const inputStyle = {
  outline: 0,
  padding: 10,
  border: "solid 1px #E0E0E0",
  borderRadius: 10,
  fontSize: 18,
  fontWeight: 600,
  color: "#202020"
};

const buttonContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 10
};

const buttonTextStyle = {
  fontSize: 20,
  fontWeight: 700
};

const resetStyle = {
  cursor: "pointer",
  color: "#2020F0",
  marginLeft: "auto",
  marginRight: "auto",
  fontSize: 14,
  fontWeight: 400
};

function Login(props) {
  const { setToken } = useStore();

  async function onLogin(e) {
    const password = document.getElementById("password").value;

    const loginRequest = await fetch(process.env.REACT_APP_API + "/auth/login", {
      headers: {
        "content-type": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        password
      })
    }).catch((err) => {
      console.error(err);
      Swal.fire({
        title: "로그인 실패",
        text: err.toString(),
        icon: "error",
        confirmButtonText: "확인"
      });
    });

    if (!loginRequest) return;

    if (loginRequest.status === 200) {
      const { token } = await loginRequest.json();
      setToken(token);
    } else {
      Swal.fire({
        title: "로그인 실패",
        text: await loginRequest.text(),
        icon: "error",
        confirmButtonText: "확인"
      });
    }
  }

  async function onFindPassword(e) {
    const resetCodeRequest = await fetch(process.env.REACT_APP_API + "/auth/resetcode", {
      method: "POST"
    }).catch((err) => {
      console.error(err);
      Swal.fire({
        title: "비밀번호 찾기 실패",
        text: err.toString(),
        icon: "error",
        confirmButtonText: "확인"
      });
    });

    if (!resetCodeRequest) return;

    if (resetCodeRequest.status !== 204) {
      Swal.fire({
        title: "비밀번호 찾기 실패",
        text: await resetCodeRequest.text(),
        icon: "error",
        confirmButtonText: "확인"
      });
      return;
    }

    const resetPassword = await Swal.fire({
      title: "비밀번호 찾기",
      html: [
        "<span>reset_password.txt 파일에 저장된 코드와<br/>새로운 비밀번호를 입력해주세요.</span>",
        "<input id='swal2-code' type='text' class='swal2-input' placeholder='코드'>",
        "<input id='swal2-password' type='text' class='swal2-input' placeholder='새로운 비밀번호'>"
      ].join(""),
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      preConfirm: () => new Promise((resolve) => resolve({
        code: document.getElementById("swal2-code").value,
        password: document.getElementById("swal2-password").value
      }))
    });

    if (resetPassword.isConfirmed) {
      const resetPasswordRequest = await fetch(process.env.REACT_APP_API + "/auth/reset", {
        headers: {
          "content-type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(resetPassword.value)
      }).catch(err => {
        console.error(err);
        Swal.fire({
          title: "비밀번호 찾기 실패",
          text: err.toString(),
          icon: "error",
          confirmButtonText: "확인"
        });
      });

      if (!resetPasswordRequest) return;

      if (resetPasswordRequest.status === 200) {
        const { token } = await resetPasswordRequest.json();

        await Swal.fire({
          title: "비밀번호 변경 완료",
          text: "비밀번호가 변경되었습니다.",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        });

        setToken(token);
      } else {
        Swal.fire({
          title: "비밀번호 찾기 실패",
          text: await resetPasswordRequest.text(),
          icon: "error",
          confirmButtonText: "확인"
        });
      }
    } else if (resetPassword.isDismissed) {
      fetch(process.env.REACT_APP_API + "/auth/resetcode", {
        method: "DELETE"
      }).catch(err => {
        console.error(err);
        Swal.fire({
          title: "비밀번호 찾기 실패",
          text: err.toString(),
          icon: "error",
          confirmButtonText: "확인"
        });
      });
    }
  }

  return (<>
    <div style={ containerStyle }>
      <svg style={ iconStyle } xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
      </svg>
      <span style={ titleStyle }>애니메이션 관리</span>
      <div style={ inputBoxStyle }>
        <input id="password" type="password" style={ inputStyle } placeholder="비밀번호 입력"/>
        <div style={ buttonContainerStyle }>
          <Button text="로그인" textStyle={ buttonTextStyle } onClick={ onLogin }/>
          <span style={ resetStyle } onClick={ onFindPassword }>비밀번호를 잊으셨나요?</span>
        </div>
      </div>
    </div>
  </>);
}

export default Login;
